var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2181_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#EFC84A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M367.28 109.339H144.773C137.413 109.339 131.493 115.259 131.493 122.566V389.446C131.493 393.126 133.04 396.486 135.493 398.886L248.41 511.809C250.938 511.884 253.455 512.001 255.999 512.001C397.386 512.001 511.999 397.388 511.999 256.001C511.999 253.462 511.882 250.956 511.807 248.433L376.4 113.019C374.053 110.725 370.8 109.339 367.28 109.339Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.253 109.333H144.747C137.435 109.333 131.504 115.264 131.504 122.576V389.424C131.504 396.736 137.435 402.667 144.747 402.667H367.254C374.566 402.667 380.497 396.736 380.497 389.424V122.576C380.496 115.264 374.565 109.333 367.253 109.333Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.162 130.667H152.837V359.952H359.162V130.667Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.837 359.952L359.163 130.667V359.952H152.837Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 126.101C259.193 126.101 261.781 123.513 261.781 120.32C261.781 117.127 259.193 114.539 256 114.539C252.807 114.539 250.219 117.127 250.219 120.32C250.219 123.513 252.807 126.101 256 126.101Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 395.493C247.765 395.493 241.061 388.789 241.061 380.554C241.061 372.319 247.765 365.615 256 365.615C264.235 365.615 270.939 372.319 270.939 380.554C270.939 388.789 264.235 395.493 256 395.493ZM256 370.949C250.704 370.949 246.395 375.258 246.395 380.554C246.395 385.85 250.704 390.159 256 390.159C261.296 390.159 265.605 385.85 265.605 380.554C265.605 375.258 261.296 370.949 256 370.949Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 122.608C257.264 122.608 258.288 121.584 258.288 120.32C258.288 119.056 257.264 118.032 256 118.032C254.736 118.032 253.712 119.056 253.712 120.32C253.712 121.584 254.736 122.608 256 122.608Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.557 163.755H176.48V169.088H335.557V163.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.557 192.533H176.48V197.866H335.557V192.533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.557 221.296H176.48V226.629H335.557V221.296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.557 250.069H176.48V255.402H335.557V250.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.557 278.827H176.48V284.16H335.557V278.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.787 307.611H176.48V312.944H289.787V307.611Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2181_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletSvgrepoCom1);
export default __webpack_public_path__ + "static/media/tablet-svgrepo-com (1).34c6bd19eaec3c62437f67974455c564.svg";
export { ForwardRef as ReactComponent };